export default __webpack_public_path__ + "0c3fe0c337067d772c2329f15d6b0fc4.png";